import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { AuthProvider } from '../../core/auth/auth.config';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="govuk-width-container">
      <main class="govuk-main-wrapper" id="main-content" role="main">
        <div class="govuk-grid-row">
          <div class="govuk-grid-column-two-thirds">
            
            <h1 class="govuk-heading-xl">
              Prihlásenie do eDesk
            </h1>
            
            <p class="govuk-body-l">
              Pre prístup do elektronickej schránky sa prihláste pomocou externého prihlasovacieho systému.
            </p>

            <div class="govuk-inset-text">
              <p class="govuk-body">
                <strong>Bezpečné prihlásenie</strong> pomocou OpenID Connect (OIDC).
                Vaše prihlasovacie údaje zostávajú v externom systéme a nie sú zdieľané s touto aplikáciou.
              </p>
            </div>

            <button 
              class="govuk-button govuk-button--start" 
              data-module="govuk-button"
              (click)="login()"
              type="button">
              Prihlásiť sa
              <svg class="govuk-button__start-icon" xmlns="http://www.w3.org/2000/svg" width="17.5" height="19" viewBox="0 0 33 40" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z"/>
              </svg>
            </button>

            <h2 class="govuk-heading-m govuk-!-margin-top-6">
              Pred prihlásením
            </h2>

            <p class="govuk-body">
              Uistite sa, že máte platné prihlasovacie údaje do externého systému.
            </p>

            <details class="govuk-details" data-module="govuk-details">
              <summary class="govuk-details__summary">
                <span class="govuk-details__summary-text">
                  Technické informácie
                </span>
              </summary>
              <div class="govuk-details__text">
                <p class="govuk-body-s">
                  Táto aplikácia používa štandard OpenID Connect (OIDC) pre autentifikáciu.
                  Po kliknutí na tlačidlo "Prihlásiť sa" budete presmerovaný na externý prihlasovací server.
                </p>
                <p class="govuk-body-s">
                  Po úspešnom prihlásení budete automaticky vrátený späť do aplikácie s platným autentifikačným tokenom.
                </p>
              </div>
            </details>

          </div>
        </div>
      </main>
    </div>
  `,
  styles: [`
    /* GOV.UK Frontend štýly sú dedené globálne */
    .govuk-main-wrapper {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  `]
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  provider: AuthProvider = 'default';

  async ngOnInit() {
    console.log('LoginComponent: Kontrolujem auth status...');

    // Read provider from route parameters immediately
    this.provider = (this.route.snapshot.params['provider'] as AuthProvider) || 'default';
    console.log('LoginComponent: Provider:', this.provider);

    // Also subscribe to param changes (in case route changes while on this component)
    this.route.params.subscribe(params => {
      const newProvider = (params['provider'] as AuthProvider) || 'default';
      if (newProvider !== this.provider) {
        this.provider = newProvider;
      }
    });

    // Wait for initial auth check to complete (includes silent login attempt)
    await this.authService.waitForAuthenticationComplete();
    
    // If already authenticated (callback processed or silent login succeeded)
    if (this.authService.isLoggedIn()) {
      console.log('LoginComponent: Uz prihlaseny, presmerovavam na hlavnu stranku');
      this.router.navigateByUrl('');
      return;
    }
    
    // Silent login was attempted and failed (or user logged out) - show login button
    console.log('LoginComponent: Not authenticated, showing login page');
    
    // Subscribe to auth status changes for when manual login completes
    this.authService.isAuthenticated$.subscribe(isAuth => {
      console.log('LoginComponent: Auth status:', isAuth);
      if (isAuth) {
        console.log('LoginComponent: Prihlasenie uspesne, presmerovavam na hlavnu stranku');
        this.router.navigateByUrl('');
      }
    });
  }

  login() {
    console.log('Tlacidlo Prihlasit stlacene');
    console.log('Using provider:', this.provider);
    this.authService.login(undefined, this.provider);
  }
}
